import React from 'react';

export const ErrorContent = ({ ErrorCode, ErrorMessage, Label, ErrorToken, CopyRight, GoBackURL }) => (

	<React.Fragment>
		<div className="empty__content">
			<div className="error">
				<div className="error__img">
					<div className="error__img-text"></div>
					<div className="error__img-player"><span></span></div>
					<div className="error__img-hit"></div>
					<div className="error__img-ball"></div>
				</div>
				<div className="error__info">
					<div className="error__label">
						<span className="error__text">{ErrorCode}</span>
					</div>
					<div className="error__code" >{ErrorToken}</div>
					<div className="error__title">{Label.lbl_oops}</div>
					<div className="error__msg">
						<div className="error__subtitle">{Label.lbl_something_wrong}</div>
						<div className="error__desc" dangerouslySetInnerHTML={{ __html: ErrorMessage }}>
						</div>
					</div>
					{GoBackURL && (
						<a href={GoBackURL} className="error__back">
							{Label.lbl_back}
						</a>
					)}
				</div>
			</div>
		</div>
		<div className="empty__footer">
			{CopyRight}
		</div>
	</React.Fragment>
);

export const ErrorContent188 = ({ ErrorCode, ErrorMessage, Label, ErrorToken }) => (
	<div className="cv-error__content">
		<div className="cv-error__img"></div>
		<div className="cv-error__main">
			<div className="cv-error__caption">
				<div className="cv-text-title">{Label.lbl_oops}</div>
				<div className="cv-error__label">
					<div className="cv-text-label">
						<span className="cv-text">{ErrorCode}</span>
					</div>
				</div>
				<div className="cv-error__code">{ErrorToken}</div>
		    </div>
			<div className="cv-error__info">
				<div className="cv-text-title">{Label.lbl_something_wrong}</div>
				<div className="cv-text-group">
					<span
						className="cv-text"
						dangerouslySetInnerHTML={{ __html: ErrorMessage }}
					/>
				</div>
			</div>
		</div>
	</div>
);